<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M17.8667 4H6.13333C4.96 4 4 4.8 4 5.77778V18.2222C4 19.2 4.96 20 6.13333 20H17.8667C19.04 20 20 19.2 20 18.2222V5.77778C20 4.8 19.04 4 17.8667 4Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>